import * as actionTypes from './action_types';

export const changeIsDesktop = value => ({
  type: actionTypes.onChangeIsDesktop,
  value,
});
